"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  maxWidth: _constants.maxWidth,
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center'
}));